import React from "react";
import { Wrench, Sparkles, ShieldCheck, PackageOpen, Check, ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { company } from "../mock";
import { PageHeader } from "./Contatti";

const details = [
  {
    Icon: Wrench,
    title: "Manutenzione",
    image: "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description: "Servizi di manutenzione ordinaria e straordinaria per impianti industriali, attrezzature e infrastrutture aziendali. Interventi programmati o su chiamata.",
    items: ["Manutenzione impianti elettrici", "Idraulica industriale", "Riparazione macchinari", "Piccoli lavori di muratura", "Verifiche periodiche"],
  },
  {
    Icon: Sparkles,
    title: "Pulizia",
    image: "https://images.pexels.com/photos/6195274/pexels-photo-6195274.jpeg?auto=compress&cs=tinysrgb&w=900",
    description: "Servizi di pulizia professionali per uffici, capannoni industriali, spazi comuni e aree produttive con prodotti certificati e personale qualificato.",
    items: ["Pulizia uffici e showroom", "Sanificazione ambienti", "Pulizia industriale", "Pulizia post-cantiere", "Manutenzione aree verdi"],
  },
  {
    Icon: ShieldCheck,
    title: "Portierato",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description: "Servizio di portineria e reception per aziende, complessi industriali e centri direzionali. Personale formato e affidabile.",
    items: ["Controllo accessi", "Reception e accoglienza", "Gestione visitatori", "Vigilanza non armata", "Centralino e smistamento"],
  },
  {
    Icon: PackageOpen,
    title: "Facchinaggio",
    image: "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&w=900",
    description: "Gestione completa di movimentazione, carico/scarico e logistica interna per magazzini, fiere ed eventi. Squadre operative dedicate.",
    items: ["Carico e scarico merci", "Movimentazione interna", "Traslochi industriali", "Allestimento fiere", "Gestione magazzino"],
  },
];

const Servizi = () => (
  <>
    <PageHeader title="I nostri servizi" subtitle="Un partner unico per ferramenta, manutenzione, pulizia e logistica. Soluzioni su misura per ogni esigenza aziendale." />
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 space-y-20">
        {details.map((s, i) => (
          <div key={s.title} className={`grid lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
            <div className="relative [direction:ltr]">
              <img src={s.image} alt={s.title} loading="lazy" className="rounded-2xl shadow-xl w-full aspect-[4/3] object-cover" />
              <div className="absolute -bottom-5 -left-5 w-16 h-16 rounded-2xl bg-[#00A859] flex items-center justify-center shadow-xl">
                <s.Icon className="w-8 h-8 text-white" />
              </div>
            </div>
            <div className="[direction:ltr]">
              <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">Servizio professionale</span>
              <h2 className="text-4xl font-extrabold text-[#0B2545] tracking-tight mb-5">{s.title}</h2>
              <p className="text-gray-600 leading-relaxed mb-6">{s.description}</p>
              <ul className="space-y-2.5 mb-7">
                {s.items.map((it) => (
                  <li key={it} className="flex items-center gap-2.5 text-sm text-gray-700">
                    <span className="w-5 h-5 rounded-full bg-[#00A859]/10 flex items-center justify-center shrink-0">
                      <Check className="w-3 h-3 text-[#00A859]" />
                    </span>
                    {it}
                  </li>
                ))}
              </ul>
              <Link to="/contatti" className="inline-flex items-center gap-2 bg-[#00A859] hover:bg-[#00874A] text-white font-bold px-6 py-3.5 rounded-full text-sm uppercase tracking-wide transition-colors">
                Richiedi preventivo <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="py-16 bg-gradient-to-r from-[#00A859] to-[#00874A]">
      <div className="max-w-[1400px] mx-auto px-6 text-center text-white">
        <h3 className="text-3xl md:text-4xl font-extrabold mb-4">Parliamo del tuo progetto</h3>
        <p className="text-white/90 mb-7 max-w-2xl mx-auto">Contatta il nostro team commerciale per una consulenza gratuita.</p>
        <a href={`tel:${company.telRaw}`} className="inline-flex items-center gap-2 bg-white text-[#00874A] font-bold px-7 py-4 rounded-full text-sm uppercase tracking-wide hover:bg-gray-100 transition-colors">
          <Phone className="w-4 h-4" /> {company.tel}
        </a>
      </div>
    </section>
  </>
);

export default Servizi;
